'use strict'

/* -----------------------------------------------------------------------------
 * dependencies
 * -------------------------------------------------------------------------- */

// 3rd party
import React from 'react'

// walrus
import Box from '@components/kit/box'
import Button from '@components/kit/button'
import { BoxLink } from '@components/kit/link'
import Text from '@components/kit/text'

// lib
import AppShell from '@components/ui/app-shell'
import PageHeader from '@components/ui/page-header'
import { useAuthStore } from '@store/Auth'

/* -----------------------------------------------------------------------------
 * SettingsCard
 * -------------------------------------------------------------------------- */

type SettingsCardProps = {
  children: React.ReactNode
}

const SettingsCard = ({ children }: SettingsCardProps) => (
  <Box
    bg='proSurface'
    borderColor='proBorder'
    borderRadius='proXl'
    borderStyle='solid'
    borderWidth={1}
    boxShadow='proTable'
    mb='16'
    overflowX='hidden'
    overflowY='hidden'
  >
    {children}
  </Box>
)

/* -----------------------------------------------------------------------------
 * Settings
 * -------------------------------------------------------------------------- */

function Settings() {
  // signs this device out on flipper; the other devices stay logged in
  const handleLogout = () => {
    useAuthStore.getState().logout()
  }

  return (
    <AppShell activePage='settings' label='Settings'>
      <PageHeader title='Settings' />

      <Box maxWidth={640} width='100%'>
        <SettingsCard>
          <BoxLink path='/settings/password-reset'>
            <Box alignItems='center' p='16'>
              <Text font='pro.text.14.semibold' textColor='proAccent'>
                Update password
              </Text>
            </Box>
          </BoxLink>
          <BoxLink path='/settings/devices'>
            <Box
              alignItems='center'
              borderColor='proDivider'
              borderTopStyle='solid'
              borderTopWidth={1}
              p='16'
            >
              <Text font='pro.text.14.semibold' textColor='proAccent'>
                Devices
              </Text>
            </Box>
          </BoxLink>
        </SettingsCard>

        <Button variant='secondary' onPress={handleLogout}>
          Logout
        </Button>
      </Box>
    </AppShell>
  )
}

export default Settings
